// src/pages/MediaPage.jsx
import React, { useMemo, useState } from "react";
import {
  Layout,
  Typography,
  Row,
  Col,
  Grid,
  Tag,
  Space,
  Modal,
  Image,
  Button,
  Pagination,
} from "antd";
import { Link } from "react-router-dom";
import Footer from "../Layouts/IcastFooter";
import IcastHeader from "../Layouts/IcastHeader";

import img1 from "../Assets5/01.png";
import img2 from "../Assets5/02.png";
import img3 from "../Assets5/03.png";
import img4 from "../Assets5/04.png";
import img5 from "../Assets5/05.png";
import img6 from "../Assets5/06.png";
import img7 from "../Assets5/07.png";
import img8 from "../Assets5/08.png";
import img9 from "../Assets5/09.png";
import img10 from "../Assets5/10.png";
import img11 from "../Assets5/11.png";
import img12 from "../Assets5/12.png";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const PRESS_ITEMS = [
  {
    id: 1,
    title:
      "Pakistan to lead global dialogue on space applications with ICAST 2025.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://leadpakistan.com.pk/news/icast-2025-concludes/",
    image: img1,
  },
  {
    id: 2,
    title:
      "Global space science conference ends in Islamabad with focus on sustainability.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://www.geo.tv/latest/634629-global-space-science-conference-ends-in-islamabad-with-focus-on-sustainability",
    image: img2,
  },
  {
    id: 3,
    title:
      "The region’s largest space science conference has been inaugurated in Pakistan.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://www.dawnnews.tv/news/1273928",
    image: img3,
  },
  {
    id: 4,
    title:
      "Pakistan hosts ICAST-2025, bringing global space community to Islamabad.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://www.app.com.pk/national/pakistan-hosts-icast-2025-bringing-global-space-community-to-islamabad/",
    image: img4,
  },
  {
    id: 5,
    title:
      "Global Space Conference: Launch of worldwide exchange on satellite technology and artificial intelligence.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://wenews.pk/news/389142/",
    image: img5,
  },
  {
    id: 6,
    title:
      "The Global Space Conference 2025 has commenced under Pakistan’s hosting.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://dailypakistan.com.pk/19-Nov-2025/1889251",
    image: img6,
  },
  {
    id: 7,
    title:
      "By securing the hosting of the Global Space Conference 2025, Pakistan has achieved a significant milestone in advancing the scientific domain.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://humnews.pk/latest/558529/",
    image: img7,
  },
  {
    id: 8,
    title:
      "Islamabad: Pakistan has become a focal point of global scientific attention, marking a significant milestone in the advancement of science.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://urdu.arynews.tv/world-space-conference-begins-in-islamabad/",
    image: img8,
  },
  {
    id: 9,
    title:
      "Islamabad (Dunya News): Pakistan has achieved a major milestone in the world of science and technology by earning the honor of hosting the International Conference on Applications of Space Science and Technology (ICAST) 2025.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://urdu.dunyanews.tv/index.php/ur/Technology/918524",
    image: img9,
  },
  {
    id: 10,
    title:
      "Pakistan marked a significant milestone in space journey with ICAST-2025.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://globalnewspakistan.com/2025/11/18/pakistan-marked-a-significant-milestone-in-space-journey-with-icast-2025/",
    image: img10,
  },
  {
    id: 11,
    title:
      "A three-day International Conference on Applications of Space Science and Technology ICAST 2025 will start at the Institute of Space Technology in Islamabad tomorrow.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://www.radio.gov.pk/17-11-2025/global-space-conference-to-start-in-islamabad-tomorrow",
    image: img11,
  },
  {
    id: 12,
    title:
      "Islamabad to host three-day global space conference drawing participants from 25 countries.",
    outlet: "Press Release",
    date: "November 2025",
    link: "https://www.arabnews.com/node/2622937/pakistan",
    image: img12,
  },
];

const PAGE_SIZE = 4;

const Press = () => {
  const screens = useBreakpoint();
  const [selectedItem, setSelectedItem] = useState(null);

  // ✅ pagination
  const [currentPage, setCurrentPage] = useState(1);

  const titleFontSize = screens.xl
    ? 48
    : screens.lg
    ? 46
    : screens.md
    ? 40
    : 32;
  const pagePadding = screens.md ? 40 : 16;
  const imageHeight = screens.md ? 200 : 220;

  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const paginatedItems = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;
    return PRESS_ITEMS.slice(start, end);
  }, [currentPage]);

  return (
    <>
      <IcastHeader />

      <Title
        style={{
          textAlign: "left",
          padding: screens.xs ? "18px 18px" : "20px 40px",
          fontFamily: "Inter, sans-serif",
          fontWeight: 800,
          fontSize: titleFontSize,
          backgroundColor: "#EEF0F2",
          margin: 0,
        }}
      >
        Media & Press Coverage
      </Title>

      <Layout style={{ backgroundColor: "#ffffff", overflowX: "hidden" }}>
        {/* Press List */}
        <Content style={{ padding: `0 ${pagePadding}px 20px` }}>
          <Row gutter={[0, 24]}>
            {paginatedItems.map((item) => (
              <Col key={item.id} span={24}>
                <div
                  onClick={() => setSelectedItem(item)}
                  style={{
                    cursor: "pointer",
                    maxWidth: 1100,
                    margin: "0 auto",
                    padding: screens.md ? "18px 0" : "0",
                    borderBottom: "1px solid #EFF0F2",
                  }}
                >
                  <Row gutter={[16, 16]} align="middle">
                    {/* Image */}
                    <Col xs={24} md={8}>
                      <div style={{ width: "100%", lineHeight: 0 }}>
                        <Image
                          src={item.image}
                          preview={false}
                          style={{
                            width: "100%",
                            height: imageHeight,
                            display: "block",
                          }}
                          imgStyle={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>
                    </Col>

                    {/* Text */}
                    <Col xs={24} md={16}>
                      <Space
                        direction="vertical"
                        size={6}
                        style={{ width: "100%" }}
                      >
                        <Tag color="blue">{item.outlet}</Tag>

                        <Title level={4} style={{ margin: 0 }}>
                          {item.title}
                        </Title>

                        <Text type="secondary">{item.date}</Text>

                        <Button
                          type="link"
                          style={{ padding: 0, fontWeight: 600 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openLink(item.link);
                          }}
                        >
                          Read full story →
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>

          {/* ✅ Pagination */}
          <div
            style={{
              maxWidth: 1100,
              margin: "22px auto 0",
              display: "flex",
              justifyContent: screens.xs ? "center" : "flex-end",
            }}
          >
            <Pagination
              current={currentPage}
              pageSize={PAGE_SIZE}
              total={PRESS_ITEMS.length}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>
        </Content>

        {/* Modal Preview */}
        <Modal
          open={!!selectedItem}
          onCancel={() => setSelectedItem(null)}
          footer={null}
          width={screens.md ? 900 : "95%"}
          destroyOnClose
        >
          {selectedItem && (
            <Row gutter={[16, 16]} align="middle">
              {/* Image */}
              <Col xs={24} md={12}>
                <div style={{ width: "100%", lineHeight: 0 }}>
                  <Image
                    src={selectedItem.image}
                    preview={false}
                    style={{
                      width: "100%",
                      height: screens.md ? 360 : 220,
                      display: "block",
                    }}
                    imgStyle={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </Col>

              {/* Text */}
              <Col xs={24} md={12}>
                <Space direction="vertical" size={10} style={{ width: "100%" }}>
                  <Tag color="blue">{selectedItem.outlet}</Tag>

                  <Title level={4} style={{ margin: 0 }}>
                    {selectedItem.title}
                  </Title>

                  <Text type="secondary">{selectedItem.date}</Text>

                  <Button
                    type="primary"
                    onClick={() => openLink(selectedItem.link)}
                  >
                    Open news link
                  </Button>
                </Space>
              </Col>
            </Row>
          )}
        </Modal>
      </Layout>

      <Footer />
    </>
  );
};

export default Press;
